interface IPosition {
  x: number
  y: number
}

interface IFlip {
  x: boolean
  y: boolean
}

export enum MediaStatus {
  PENDING = 'pending',
  OK = 'ok',
  ERROR = 'error'
}

export type TMediaStatus = MediaStatus
export interface ITextData {
  text: string
  fontPostScriptName: string
  fontPath: string
  fontSize: number
  fillColor: string
  strokeColor: string
  strokeThickness: number
}

export interface IMediaItemMeta {
  path?: string | null
  originalHeight?: number
  originalWidth?: number
  originalDuration?: number
  trimStart?: number
  previewPath?: string
  status?: TMediaStatus
  volume?: number
  textData?: ITextData
  assetParentId?: string
  playbackSpeed?: number
}

export type TAiMediaItemType = 'aiImage' | 'aiVideo'

export type TMediaItemType = 'image' | 'video' | 'text' | TAiMediaItemType

export type TAiMediaSourceType = 'ai-image' | 'ai-video'

export interface IMediaItem {
  id: string
  assetId: string
  type: TMediaItemType
  height: number
  width: number
  rotation: number
  duration: number
  startTime: number
  zIndex: number
  coordinates: IPosition
  flip?: IFlip
  meta: IMediaItemMeta
}

export type TPartialMediaItem = Partial<Omit<IMediaItem, 'meta'>> & {
  meta: Partial<IMediaItemMeta>
}

export interface IMyFilesMediaItem {
  id: number
  folderId: number
  createdAt: string
  updatedAt: string
  fileName: string
  filePath: string
  downloadPath: string
  fileSize: number
  mime: string
  width: number
  height: number
  thumbnailPath: string
  duration?: number
  thumbnailVideo?: string
  webpPath?: string
  sourceType?: TAiMediaSourceType
  assetId?: string
}

export type TMyFilesMediaItems = IMyFilesMediaItem[]

export interface IBaseMediaItem {
  id?: string
  mediaId?: number
  assetId?: string
  fileName: string
  type: TMediaItemType
  originalWidth: number
  originalHeight: number
  path?: string | null
  previewPath?: string
  duration: number
  status?: MediaStatus
  assetParentId?: string
  thumbnail?: string | null
  imageUrl?: string | null
}

export interface IBaseUploadedMediaItem {
  id: number
  filePath: string
}

export interface IUploadMediaItem {
  id: string | number
  file: File
  type: TMediaItemType
}
